import { USER_ROLES } from '@/constants/userRoles'
import type { PermissionHandlerParams } from '@/features/authorization/contexts/PermissionsContext'
import { getCountryCodeByLocation } from '@/utils/locations'

const REVENUE_ALLOWED_COUNTRIES = new Set(['fi', 'no'])

function isInRevenueAllowedCountry(location: string | undefined): boolean {
  if (!location) return false
  const country = getCountryCodeByLocation(location)
  return country !== undefined && REVENUE_ALLOWED_COUNTRIES.has(country)
}

export const hasRevenuePermissions = ({ loggedInUser, site }: PermissionHandlerParams) => {
  if (!site) return false

  const hasAllowedRole =
    loggedInUser?.role === USER_ROLES.ADMINISTRATORS.value ||
    loggedInUser?.role === USER_ROLES.CUSTOMER_MANAGERS.value ||
    loggedInUser?.role === USER_ROLES.RESOURCE_OWNERS.value

  const isDirectSite = site.partner?.partnerCode === 'SYMPOWER'

  return hasAllowedRole && isInRevenueAllowedCountry(site.location) && isDirectSite
}
